import { TFunction } from 'i18next';

interface IErrorMessages {
  [key: string]: string;
}

export enum ApiErrorKeys {
  INVALID_DATA = 'INVALID_DATA',
}

export const getApiErrorMessage = (t: TFunction<string[]>, key: string | undefined) => {
  const errorMessages: IErrorMessages = {
    [ApiErrorKeys.INVALID_DATA]: t('common:api-error-messages.INVALID_DATA'),
  };

  let errorMessage = '';
  if (key !== undefined) {
    errorMessage = errorMessages[key] ?? t('common:api-error-messages.something-went-wrong');
  }

  return errorMessage;
};

export const getErrorMessage = (
  t: TFunction<string[]>,
  key: string | undefined,
  keyValues?: { [key: string]: string },
) => {
  const errorMessages: IErrorMessages = {
    required: t('common:error-messages.required', { ...keyValues }),
    isValidPhone: t('common:error-messages.invalid-phone', { ...keyValues }),
    isValidTyreNumber: t('common:error-messages.invalid-tyres-number', { ...keyValues }),
    isValidNumberOfPassengers: t('common:error-messages.invalid-passanger-numbers', { ...keyValues }),
  };

  let errorMessage = '';
  if (key !== undefined) {
    errorMessage = errorMessages[key] ?? t('common:error-messages.error');
  }

  return errorMessage;
};
